import React from "react"
import { navigate } from "gatsby"

import Airtable from "airtable"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as registrationFormSingaporeStyles from "../../styles/landing_pages/RegistrationFormSingapore.module.css"

const ISOCountries = require("i18n-iso-countries")
ISOCountries.registerLocale(require("i18n-iso-countries/langs/en.json"))

export default function Application(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const [data, setData] = React.useState({
    email: ``,
    firstName: ``,
    lastName: ``,
    phone: ``,
    company: ``,
    country: ``,
    jobTitle: ``,
    dietary: ``,
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = evt => {
    evt.preventDefault()

    setHasError(false)

    let filteredData = JSON.parse(JSON.stringify(data))
    
    filteredData.country = ISOCountries.getName(data.country, "en")

    const base = new Airtable({
      apiKey: process.env.GATSBY_AIRTABLE_API_TOKEN,
    }).base("appWxpLfct3p6SF6z")

    base("RegistrationSingapore").create(
      [
        {
          fields: filteredData,
        },
      ],
      function (err, records) {
        if (err) {
          console.error(err)
          setHasError(true)
          return
        }
        records.forEach(function (record) {
          const submittedPage = record && record.fields[`thankYouPage`]
          setSubmitted(true)
          if (submittedPage) navigate(submittedPage)
        })
      },
    )
  }

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const info = content.childNodes
    .filter(node => node.classNames === "text")
    .map(t => t.innerHTML)

  return (
    <>
      <div className={`row ${registrationFormSingaporeStyles.wrapper}`}>
        <div className={`col-12 ${registrationFormSingaporeStyles.holder}`}>
          <h1>{title}</h1>
          {info.map((t, idx) => (
            <p
              dangerouslySetInnerHTML={{ __html: t }}
              className={registrationFormSingaporeStyles.main}
              key={idx}
            />
          ))}
        </div>
        {!isSubmitted && (
          <div
            className={`row ${registrationFormSingaporeStyles.registrationFormWrapper}`}
          >
            <div
              className={`col-12 ${registrationFormSingaporeStyles.submitRegistrationForm}`}
            >
              <form
                className={`row ${registrationFormSingaporeStyles.registrationForm}`}
                onSubmit={handleSubmit}
              >
                <div className={`row ${registrationFormSingaporeStyles}`}>
                  <div
                    className={`col ${registrationFormSingaporeStyles.info}`}
                  >
                    <input
                      id="firstName"
                      type="text"
                      className="form-control"
                      placeholder="First name *"
                      aria-label="First name"
                      name="firstName"
                      value={data.firstName}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                  <div
                    className={`col ${registrationFormSingaporeStyles.info}`}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name *"
                      aria-label="Last name"
                      id="lastName"
                      name="lastName"
                      value={data.lastName}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${registrationFormSingaporeStyles}`}>
                  <div
                    className={`col ${registrationFormSingaporeStyles.info}`}
                  >
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Business Email *"
                      aria-label="Business Email"
                      id="email"
                      name="email"
                      value={data.email}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                  <div
                    className={`col ${registrationFormSingaporeStyles.info}`}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone"
                      aria-label="Phone"
                      id="phone"
                      name="phone"
                      value={data.phone}
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
              
                <div className={`row ${registrationFormSingaporeStyles}`}>
                <div
                    className={`col ${registrationFormSingaporeStyles.info}`}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Job title *"
                      aria-label="Job title"
                      id="jobTitle"
                      name="jobTitle"
                      value={data.jobTitle}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                  <div
                    className={`col ${registrationFormSingaporeStyles.info}`}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company *"
                      aria-label="Company"
                      id="company"
                      name="company"
                      value={data.company}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
             
                </div>
                <div className={`row ${registrationFormSingaporeStyles}`}>
                  <div
                    className={`col ${registrationFormSingaporeStyles.location}`}
                  >
                    <label>
                      Which country are you located in?
                      <select
                        value={data.country}
                        name="country"
                        required
                        onChange={handleItemChange}
                      >
                        <option value="" disabled defaultValue="">
                          Select a country
                        </option>
                        {Object.entries(
                          ISOCountries.getNames("EN", {
                            select: "official",
                          }),
                        ).map((country, idx) => (
                          <option key={idx} value={country[0]}>
                            {country[1]}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                </div>
                <div
                  className={`row ${registrationFormSingaporeStyles.dietaryWrapper}`}
                >
                  <div
                    className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ${registrationFormSingaporeStyles.dietary}`}
                  >
                    <label>
                      Dietary restrictions
                      <select
                        value={data.dietary}
                        name="dietary"
                        onChange={handleItemChange}
                      >
                        <option value="" disabled defaultValue="">
                          Select
                        </option>
                        <option value="noPreference">No preference</option>
                        <option value="vegetarian">Vegetarian</option>
                        <option value="halal">Halal</option>
                        <option value="kosher">No nuts</option>
                        <option value="glutenFree">Gluten-free</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div
                  className={`row ${registrationFormSingaporeStyles.formSubmit}`}
                >
                  <div
                    className={`col ${registrationFormSingaporeStyles.submit}`}
                  >
                    <button
                      type="submit"
                      className={`${registrationFormSingaporeStyles}`}
                    >
                      Register
                    </button>
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        {isSubmitted && (
          <>
            <h5>
              Thank you for reaching out.
              <br />
              We will be in touch soon!
            </h5>
            <br />
            <br />
            <br />
            <br />
          </>
        )}
      </div>
    </>
  )
}
